import type { PricingList } from 'api/types/pricing.types';
import * as React from 'react';
import { useCallback, useMemo } from 'react';

import PricingPageSheet from '../PricingPageSheet';
import PricingSheetContent from '../PricingSheet';

interface PricingButtonWithEmbeddedPricingProps {
  showPricingSheet: boolean;
  isEmbedded?: boolean;
  togglePricingSheet?: (value: boolean) => void;
}

const PricingButtonWithEmbeddedPricing = ({ showPricingSheet, isEmbedded, togglePricingSheet }: PricingButtonWithEmbeddedPricingProps) => {
  const [showPricingPageSheet, setShowPricingPageSheet] = React.useState(false);
  const [serviceType, setServiceType] = React.useState<PricingList.ServiceTypes>('CLEAN_PRESS');

  const togglePricingPageSheet = React.useCallback((value: boolean) => setShowPricingPageSheet(value), []);

  const onTogglePricingSheet = React.useCallback((value: boolean) => togglePricingSheet?.(value), []);

  const handleClosePricingSheet = useCallback(() => {
    onTogglePricingSheet(false);
  }, [togglePricingSheet]);

  const handleClosePricingPageSheet = useCallback(() => {
    togglePricingPageSheet(false);
  }, [togglePricingPageSheet]);

  const onSelectService = useCallback(
    (type: PricingList.ServiceTypes) => {
      setServiceType(type);
      togglePricingPageSheet(true);
    },
    [togglePricingPageSheet]
  );

  const PricingSheetComponent = useMemo(
    () => (
      <>
        <PricingPageSheet serviceType={serviceType} show={showPricingPageSheet} onClose={handleClosePricingPageSheet} />{' '}
        <PricingSheetContent show={showPricingSheet} onSelectService={isEmbedded ? onSelectService : undefined} onClose={handleClosePricingSheet} />
      </>
    ),
    [handleClosePricingPageSheet, handleClosePricingSheet, isEmbedded, onSelectService, serviceType, showPricingPageSheet, showPricingSheet]
  );

  return PricingSheetComponent;
};

export default PricingButtonWithEmbeddedPricing;
